import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { getColor, WithTooltip } from 'basic-components';

import { Else, If, Then } from 'react-if';

import classNames from 'classnames';
import './ActionItem.scss';

const ActionItem = ({ textColor = "blue-bright", text, icon, onClick, isHighlighted = false, withTooltip = false, disabled = false, tooltipText = undefined }) => {
  const style = useMemo(() => ({
            color: disabled ? getColor("grey-medium") : getColor(textColor)
          }), [disabled, textColor]),
        ActionItemElements = (
          <div 
              className={classNames(
                "action-item",
                { "action-item--is-highlighted": isHighlighted },
                { "action-item--is-disabled": disabled },
              )}
              onClick={!disabled ? onClick : undefined}
          >
            <div className="action-item__icon">
              {icon}
            </div>
            <div 
                className="action-item__text"
                style={style}
            >
              {text}
            </div>
          </div>
        )

  return (
    <If condition={withTooltip}>
      <Then>
        {() => (
          <WithTooltip
              text={tooltipText}
          >
            {ActionItemElements}
          </WithTooltip>
        )}            
      </Then>
      <Else>
        {() => ActionItemElements}
      </Else>
    </If>
  )
}

ActionItem.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.element.isRequired,
  isHighlighted: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  tooltipText: PropTypes.string,
  withTooltip: PropTypes.bool
}

export default ActionItem;